(function () {
    'use strict';
    
    angular
    .module('szallodak-novacancy', []);
})();
